import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import { flowRight as compose } from 'lodash';
import {
  BreadcrumbContainer,
  BreadcrumbElementContainer,
  BreadcrumbElementLabel,
  BreadcrumbElementSeparator,
  StyledLocaleLink
} from './Breadcrumb.styles';
import { useNavigation } from '../../../../../../contexts/NavigationCtx';
import { LinkButton } from '../TertiaryOptions/TertiaryOptions.styles';

function Breadcrumb({ breadcrumbs, router: { query = {} } = {}, routeName, routes }) {
  const { breadcrumbVariables } = useNavigation();

  if (!breadcrumbs) return <BreadcrumbContainer />;

  // Function to find the label for a given route using array iteration
  const findLabelByRoute = (targetRoute, menuItems) =>
    menuItems?.reduce((foundLabel, { route, label, subMenu }) => {
      if (foundLabel) return foundLabel;
      if (route === targetRoute) return label?.defaultMessage?.[0]?.value || '';
      if (subMenu) return findLabelByRoute(targetRoute, subMenu);
      return '';
    }, '');

  // Find the current route label using the refactored function
  const currentRouteLabel = findLabelByRoute(routeName, routes);

  // Check if the route is present in breadcrumbs using array iteration
  const isPresent = breadcrumbs?.some(({ route }) => route === routeName);

  // Construct breadcrumbsDetails, adding the route if not present
  const breadcrumbsDetails = isPresent
    ? breadcrumbs
    : [...breadcrumbs, { label: currentRouteLabel, route: routeName, param: '' }];

  return (
    <BreadcrumbContainer>
      {breadcrumbsDetails.map(({ label: defaultLabel, route, param }, index) => {
        const label = param ? breadcrumbVariables?.[param] : defaultLabel;
        if (!label) return null;

        const isSelected = routeName === route;
        const includeSpacer = index + 1 !== breadcrumbsDetails.length;

        return (
          <BreadcrumbElementContainer key={route || index}>
            <BreadcrumbElementLabel>
              <StyledLocaleLink disabled={!route} route={route} params={{ ...query }} passHref>
                <LinkButton isSelected={isSelected}>{label}</LinkButton>
              </StyledLocaleLink>
            </BreadcrumbElementLabel>
            {includeSpacer && <BreadcrumbElementSeparator>/</BreadcrumbElementSeparator>}
          </BreadcrumbElementContainer>
        );
      })}
    </BreadcrumbContainer>
  );
}

Breadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  router: PropTypes.shape({}).isRequired,
  routeName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      route: PropTypes.string.isRequired,
      label: PropTypes.shape({
        defaultMessage: PropTypes.string
      }),
      subMenu: PropTypes.arrayOf(
        PropTypes.shape({
          route: PropTypes.string.isRequired,
          label: PropTypes.shape({
            defaultMessage: PropTypes.string
          })
        })
      )
    })
  ).isRequired
};

const composeBreadcrumb = compose(withRouter)(Breadcrumb);
export default composeBreadcrumb;
